<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="巡检点名称">
              <a-input placeholder="请输入巡检点名称" v-model="queryParam.pointName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="区域">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择区域"
                v-model="queryParam.devProcessId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('巡检点')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <yw-artificial-patrol-point-modal @ok="modalFormOk" ref="modalForm" />
  </a-card>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import YwArtificialPatrolPointModal from './modules/YwArtificialPatrolPointModal'
  import '@/assets/less/TableExpand.less'

  export default {
    name: 'YwArtificialPatrolPointList',
    mixins: [JeecgListMixin],
    components: {
      YwArtificialPatrolPointModal
    },
    data () {
      return {
        description: '巡检点管理页面',
        isorter: {
          column: 'pointName',
          order: 'asc'
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '巡检点名称',
            align: 'center',
            sorter: true,
            dataIndex: 'pointName'
          },
          {
            title: '描述',
            align: 'center',
            dataIndex: 'pointDesc'
          },
          {
            title: '区域',
            align: 'center',
            dataIndex: 'devProcessId_dictText'
          },
          {
            title: '设备数量',
            align: 'center',
            dataIndex: 'devCount'
          },
          {
            title: '编号',
            align: 'center',
            dataIndex: 'pointCode'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/device/patrol/ywArtificialPatrolPoint/list',
          delete: '/device/patrol/ywArtificialPatrolPoint/delete',
          deleteBatch: '/device/patrol/ywArtificialPatrolPoint/deleteBatch',
          exportXlsUrl: '/device/patrol/ywArtificialPatrolPoint/exportXls',
          importExcelUrl: 'device/patrol/ywArtificialPatrolPoint/importExcel'
        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'pointName', text: '巡检点名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pointDesc', text: '描述', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devProcessId', text: '区域', dictCode: '' })
        fieldList.push({ type: 'int', value: 'devCount', text: '设备数量', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pointCode', text: '编号', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
